import { createReducer, on } from '@ngrx/store';
import * as fromActions from './notifications.actions';

export interface State {
  loading: boolean;
  error: any | null;
  total: number;
}

export const initialState: State = {
  error: null,
  loading: false,
  total: 0,
};

export const reducer = createReducer(
  initialState,
  on(fromActions.fetchNotificationCount, (state) => ({ ...state, loading: true, error: null })),
  on(fromActions.fetchNotificationCountSuccessfully, (state, { count }) => {
    return {
      ...state,
      loading: false,
      total: count,
    };
  }),
  on(fromActions.fetchNotificationCountFailed, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
